import * as React from 'react'

export function DashSolidIcon() {
  return (
    <svg width="24" height="24" stroke="currentColor" xmlns="http://www.w3.org/2000/svg">
      <circle cx={12} cy={12} r={8} fill="none" strokeWidth={2} strokeLinecap="round" />
    </svg>
  )
}
